import React from 'react';
import { Github, Linkedin, Twitter, Instagram, Heart, BookOpen } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 bg-zinc-950 border-t border-zinc-900">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <img 
              src={personalInfo.logo} 
              alt="Nevzat ÇIRAK Logo" 
              className="h-6 w-auto opacity-80 hover:opacity-100 transition-opacity"
            />
            <p className="text-zinc-500 text-sm flex items-center gap-1">
              © {currentYear} {personalInfo.name}. Made with
              <Heart className="w-4 h-4 text-red-500 fill-red-500" />
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href={personalInfo.socialLinks.github}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-zinc-500 hover:text-white transition-colors"
              title="GitHub"
            >
              <Github size={20} />
            </a>
            <a
              href={personalInfo.socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-zinc-500 hover:text-white transition-colors"
              title="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
            <a
              href={personalInfo.socialLinks.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-zinc-500 hover:text-white transition-colors"
              title="Twitter"
            >
              <Twitter size={20} />
            </a>
            <a
              href={personalInfo.socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-zinc-500 hover:text-white transition-colors"
              title="Instagram"
            >
              <Instagram size={20} />
            </a>
            <a
              href={personalInfo.socialLinks.medium}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-zinc-500 hover:text-white transition-colors"
              title="Medium"
            >
              <BookOpen size={20} />
            </a>
          </div>

          {/* Back to Top */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-zinc-500 hover:text-cyan-400 transition-colors"
          >
            Back to Top ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
